import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function intImageFunction() {
	if($(".wp-block-thefuturblocks-int-image").length) {
		$(".wp-block-thefuturblocks-int-image").each(function() {
			const self = $(this),
				inner = self.find(".wp-block-thefuturblocks-int-image__inner-wrapper"),
				imageWrapper = self.find(".wp-block-thefuturblocks-int-image__image"),
				image = self.find(".wp-block-thefuturblocks-int-image__image img"),
				tl = gsap.timeline({paused:true});
			if(self.hasClass("mob-nhover") && window.matchMedia("(min-width: 768px)").matches || !self.hasClass("mob-nhover")) {
				tl.fromTo(imageWrapper, {yPercent:-100}, {yPercent:0,duration:0.5,ease:"sine.out"})
				.fromTo(image, {yPercent:100}, {yPercent:0,duration:0.5,ease:"sine.out"}, "<")
				.to(inner, {height: "auto",duration:0.5}, "<")
			}

			self.on("mouseenter", () => {
				tl.play();
			}).on("mouseleave", () => {
				tl.reverse();
			})
		});
	}
}

intImageFunction();